import { render } from "./WoTActionsEditView.vue?vue&type=template&id=1b5e8c40"
import script from "./WoTActionsEditView.vue?vue&type=script&lang=js"
export * from "./WoTActionsEditView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__